import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { getOwner } from '@ember/application';
import { task } from 'ember-concurrency';
import RouteTemplate from 'ember-route-template';
import { isTesting, macroCondition } from '@embroider/macros';
import moment from 'moment-timezone';
import JwtSession from 'cpc-license-manager/services/session';
import BsButton from 'cpc-license-manager/components/bs-button';
import BsForm from 'cpc-license-manager/components/bs-form';
class LoginTemplate extends Component {
    @service
    session;
    @tracked
    password;
    @tracked
    errorMessage;
    @tracked
    username;
    _sendLoginRequest = async (credentials)=>{
        Object.assign(credentials, {
            timezone: moment.tz.guess(),
            clientTime: moment().toDate()
        });
        try {
            await this.session.authenticate('authenticator:jwt', credentials);
        } catch (e) {
            if (macroCondition(!isTesting())) {
                console.error(e);
            }
            const errorMessage = e.message;
            Object.assign(this, {
                password: null,
                errorMessage
            });
        }
    };
    login = task(waitFor(async ()=>{
        if (this.session.isOidc) {
            const owner = getOwner(this);
            owner.unregister('service:session');
            owner.register('service:session', JwtSession);
            this.session = owner.lookup('service:session');
            await this.session.setup();
        }
        await this._sendLoginRequest({
            username: this.username,
            password: this.password
        });
    }));
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    {{#unless this.session.isActuallyAuthenticated}}
      <div class="row h-75">
        <div class="card mx-auto my-auto text-center shadow login-card">
          <div class="card-body border-bottom rounded-top">
            <img src="/images/epicor-logo-blue.png" class="logo" />
            <div class="mb-0 mt-1 text-uppercase logo-text">
              Connected Process Control
            </div>
            <h5 class="fw-light mb-0 mt-3">
              License Manager
            </h5>
          </div>
          <div class="card-body">
            <BsForm @model={{this}} @onSubmit={{this.login.perform}} as |form|>
              <form.element
                @controlType="text"
                @property="username"
                as |el|
              >
                <el.control placeholder="email/username"/>
              </form.element>
              <form.element
                @controlType="password"
                @property="password"
                as |el|
              >
                <el.control placeholder="password"/>
              </form.element>
              <BsButton @type="primary" @size="md" type="submit" class="login-button">
                Login
              </BsButton>
            </BsForm>
          </div>
        </div>
      </div>
    {{/unless}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default RouteTemplate(LoginTemplate);
